import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ModelCache } from './model-cache';

const modelCacheModule = angular.module('mode.modelCache', []);

modelCacheModule.service('modelCache', downgradeInjectable(ModelCache));

export const ModelCacheModule = modelCacheModule.name;
